import { render, staticRenderFns } from "./Abstractted.vue?vue&type=template&id=94735e58&scoped=true&"
import script from "./Abstractted.vue?vue&type=script&lang=js&"
export * from "./Abstractted.vue?vue&type=script&lang=js&"
import style0 from "./Abstractted.vue?vue&type=style&index=0&id=94735e58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94735e58",
  null
  
)

export default component.exports